import { useEffect } from 'react'

/**
 * https://css-tricks.com/books/greatest-css-tricks/scroll-animation/
 */
export const useScrollCssVar = () => {
  useEffect(() => {
    const handler = () => {
      document.body.style.setProperty(
        '--scroll',
        (
          window.scrollY /
          (document.documentElement.scrollHeight -
            document.documentElement.clientHeight)
        ).toString()
      )
    }

    window.addEventListener('scroll', handler, false)

    handler()

    return () => {
      window.removeEventListener('scroll', handler, false)
    }
  }, [])
}
